jQuery_BENT(document).ready(function($) {
  /**
  *  Variant selection changed
  *  data-variant-toggle="{{variant.id}}"
  */
   $( document ).on( "variant:changed", function( evt ) {
     // console.log( evt.currentVariant );
     // $('[data-variant-toggle]').hide(0);
     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
   });

});



  function openHelpBox() {
    const helpBox = document.getElementById('helpBox');
    if (helpBox) {
      helpBox.style.display = 'block';
    }
  }

  function closeHelpBox() {
    const helpBox = document.getElementById('helpBox');
    if (helpBox) {
      helpBox.style.display = 'none';
    }
  }

  // Attach event using event delegation (most reliable method)
  document.addEventListener('click', function (e) {
    const target = e.target.closest('a[href="#helpBoxTrigger"]');

    // OPEN HELP BOX on click
    if (target) {
      e.preventDefault(); // prevent jump
      openHelpBox();
      history.replaceState(null, null, ' '); // remove # from URL
    }

    // CLOSE HELP BOX if clicked outside
    const helpBox = document.getElementById('helpBox');
    const helpContent = document.getElementById('helpBoxContent');
    const clickedInside = helpContent?.contains(e.target) || target;

    if (helpBox?.style.display === 'block' && !clickedInside) {
      closeHelpBox();
    }
  });
